import { Heading } from "@planningcenter/doxy-web"
import React from "react"
import { Loading } from "./Loading"
import { StripePaymentElement } from "./stripe"

// TODO: (if possible) mark this as the focused pane when SPE has been
// interacted with

export function PaymentMethodSelector() {
  return (
    <div>
      <Heading level={3} text="Payment method" />
      <React.Suspense fallback={<Loading />}>
        <div className="mt-1">
          <StripePaymentElement />
        </div>
      </React.Suspense>
    </div>
  )
}
